import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	textField: {
		marginTop: useTheme().spacing(1.5),
		'& input.Mui-disabled': {
			background: 'rgb(221 221 221 / 38%)',
		},
	},
	labelClass: {
		fontSize: 14,
	},
}));
export default styles;
